"use client";

import { Search, X } from "lucide-react";

type SearchNoResultProps = {
  titleText?: string;
  descriptionText?: string;
  className?: string;
};

export default function SearchNoResult({
  titleText = "மன்னிக்கவும்! எந்த முடிவும் கிடைக்கவில்லை",
  descriptionText = "நீங்கள் தேடுவதைப் பற்றி நாங்கள் வருந்துகிறோம், தயவு செய்து மீண்டும் முயற்சிக்கவும்",
  className = "",
}: SearchNoResultProps) {
  return (
    <div
      className={`w-full flex flex-col items-center justify-center text-center gap-4 p-4 ${className}`}
    >
      {/* Icon in circle */}
      <div className="relative mb-4">
        {/* Circle */}
        <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-ECEEF3 flex items-center justify-center">
          {/* Search icon centered */}
          <Search className="w-6 h-6 md:w-7 md:h-7 text-012061" />
        </div>

        {/* Arrow on top-right of circle */}
        <X className="w-4 h-4 md:w-5 md:h-5 text-012061 absolute -top-1 -right-1 -translate-x-2 translate-y-2" />
      </div>

      {/* Title text */}
      <h2 className="text-24-tamil-700 md:text-16-tamil-500 text-222222">
        {titleText}
      </h2>

      {/* Description text */}
      <p className="text-16-tamil-400 md:text-12-tamil-400 text-3D3D3D max-w-md">
        {descriptionText}
      </p>
    </div>
  );
}
